import React from 'react';
import { motion } from 'framer-motion';
import { trackContact } from '../utils/metaPixel';
export const HeroSection = () => {
  return <section id="hero" className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden bg-white" data-id="element-54">
      {/* Background glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-accent/10 rounded-full blur-[100px] pointer-events-none" data-id="element-55" />

      <div className="container mx-auto px-6 max-w-5xl relative z-10" data-id="element-56">
        <div className="text-center flex flex-col items-center" data-id="element-57">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="inline-block mb-6 px-4 py-1.5 rounded-full bg-soft/30 border border-soft/50 text-primary text-xs font-bold tracking-widest uppercase" data-id="element-58">
            Facilitadores de Salud y Bienestar
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-5xl md:text-7xl font-bold text-primary leading-tight mb-6 tracking-tight" data-id="element-59">
            Basta de sobrevivir <br className="hidden md:block" data-id="element-60" />
            <span className="text-accent relative" data-id="element-61">
              Comienza a vivir
              <span className="absolute -bottom-2 left-0 w-full h-2 bg-accent/20 rounded-full" data-id="element-62"></span>
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-lg md:text-xl text-primary/80 max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-63">
            ¿Sientes que ya intentaste de todo y nada cambia? Quitamos los
            bloqueos y traumas de tu subconsciente que te impiden tener una vida
            plena, con un método práctico, rápido y sin sufrir.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto" data-id="element-64">
            <a href="https://wa.link/r4i31b" target="_blank" rel="noopener noreferrer" onClick={trackContact} className="w-full sm:w-auto px-8 py-4 bg-primary text-white rounded-full font-bold text-lg hover:bg-primary/90 transition-all shadow-lg hover:shadow-xl hover:-translate-y-1" data-id="element-65">
              Reservá tu sesión hoy
            </a>
            <a href="#method" className="w-full sm:w-auto px-8 py-4 bg-white text-primary border-2 border-soft rounded-full font-bold text-lg hover:bg-soft/20 transition-all" data-id="element-66">
              Cómo funciona
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} className="mt-16 pt-8 border-t border-soft/50 max-w-2xl mx-auto" data-id="element-67">
            <p className="text-sm md:text-base font-medium text-primary/70 italic" data-id="element-68">
              <span className="font-bold text-primary not-italic" data-id="element-69">
                +8.000 personas
              </span>{' '}
              ya transformaron su realidad. <br className="md:hidden" data-id="element-70" />
              "No es magia, es ciencia aplicada al subconsciente."
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
};